export class ServerBoundaries {
  static readonly minNumberValue = -2147483648;
  static readonly maxNumberValue = 2147483647;
  static readonly minDateValue = new Date('1/1/1753');
}

export const MAX_NO_OF_ROWS = ServerBoundaries.maxNumberValue;
